// Central registry of all features that can be shown/hidden in the sidebar.
// Each "group" is a top-level menu entry. A group may have sub-items that
// appear underneath it when the group is expanded.
//
// `id`s here must match the activeTab values used in `App.renderContent`.

import {
  LayoutDashboard,
  Wallet,
  PiggyBank,
  Dumbbell,
  Calendar as CalendarIcon,
  Trophy,
  ShoppingCart,
  Cake,
  CalendarDays,
  CheckSquare,
  Bell,
  CircleDollarSign,
  User,
  BookHeart,
  Repeat,
  Briefcase,
  Timer,
  Fuel,
  GraduationCap,
  FolderKanban
} from 'lucide-react';

// Each label/description is an i18n key resolved by the consumer via t().
// Fallbacks live in the dictionary (see src/lib/i18n.js).
export const FEATURE_GROUPS = [
  {
    id: 'dashboard',
    label: 'nav.dashboard',
    icon: LayoutDashboard,
    description: 'navDesc.dashboard',
    items: [{ id: 'dashboard', label: 'nav.dashboard', icon: LayoutDashboard }]
  },
  {
    id: 'planning',
    label: 'nav.planning',
    icon: CalendarDays,
    description: 'navDesc.planning',
    items: [
      { id: 'calendar', label: 'nav.calendar', icon: CalendarIcon, description: 'navDesc.calendar' },
      { id: 'birthdays', label: 'nav.birthdays', icon: Cake, description: 'navDesc.birthdays' },
      { id: 'todo', label: 'nav.todo', icon: CheckSquare, description: 'navDesc.todo' },
      { id: 'reminders', label: 'nav.reminders', icon: Bell, description: 'navDesc.reminders' }
    ]
  },
  {
    id: 'finance',
    label: 'nav.finance',
    icon: CircleDollarSign,
    description: 'navDesc.finance',
    items: [
      { id: 'budget', label: 'nav.budget', icon: Wallet, description: 'navDesc.budget' },
      { id: 'savings', label: 'nav.savings', icon: PiggyBank, description: 'navDesc.savings' }
    ]
  },
  {
    id: 'fitness',
    label: 'nav.fitness',
    icon: Dumbbell,
    description: 'navDesc.fitness',
    items: [
      { id: 'fitness', label: 'nav.fitnessOverview', icon: Dumbbell, description: 'navDesc.fitnessOverview' },
      { id: 'sports', label: 'nav.sports', icon: Trophy, description: 'navDesc.sports' }
    ]
  },
  {
    id: 'personal',
    label: 'nav.personal',
    icon: User,
    description: 'navDesc.personal',
    items: [
      { id: 'diary', label: 'nav.diary', icon: BookHeart, description: 'navDesc.diary' },
      { id: 'habits', label: 'nav.habits', icon: Repeat, description: 'navDesc.habits' }
    ]
  },
  {
    id: 'work',
    label: 'nav.work',
    icon: Briefcase,
    description: 'navDesc.work',
    items: [
      { id: 'timetracker', label: 'nav.timetracker', icon: Timer, description: 'navDesc.timetracker' },
      { id: 'projects', label: 'nav.projects', icon: FolderKanban, description: 'navDesc.projects' }
    ]
  },
  {
    id: 'shopping',
    label: 'nav.shopping',
    icon: ShoppingCart,
    description: 'navDesc.shopping',
    items: [{ id: 'shopping', label: 'nav.shopping', icon: ShoppingCart }]
  },
  {
    id: 'fuel',
    label: 'nav.fuel',
    icon: Fuel,
    description: 'navDesc.fuel',
    items: [{ id: 'fuel', label: 'nav.fuel', icon: Fuel, description: 'navDesc.fuel' }]
  },
  {
    id: 'tutoring',
    label: 'nav.tutoring',
    icon: GraduationCap,
    description: 'navDesc.tutoring',
    items: [{ id: 'tutoring', label: 'nav.tutoring', icon: GraduationCap, description: 'navDesc.tutoring' }]
  }
];

// Default order = same as the array above
export const DEFAULT_GROUP_ORDER = FEATURE_GROUPS.map((g) => g.id);

// All feature/sub-item ids
export const ALL_FEATURE_IDS = FEATURE_GROUPS.flatMap((g) =>
  g.items.map((i) => i.id)
);

// Build the default enabledFeatures map (everything on by default)
export const DEFAULT_ENABLED_FEATURES = ALL_FEATURE_IDS.reduce((acc, id) => {
  acc[id] = true;
  return acc;
}, {});

export const getGroupById = (id) => FEATURE_GROUPS.find((g) => g.id === id);
